import { Section } from "@/components/ui/Section";
import { SPARK_STAGES } from "@/data/mock";

export default function Process() {
  return (
    <Section
      eyebrow="// The Spark Framework"
      title="11 stages from intake to ROI loop."
      subtitle="Spark is our AI brand strategist. It runs every new client through the same 11-stage framework so nothing gets skipped — from primary directive all the way to measurable growth loops."
    >
      <div className="relative">
        <div className="absolute left-6 top-0 bottom-0 w-px bg-gradient-to-b from-brand-blue via-brand-blue/30 to-transparent" />
        <ol className="space-y-6">
          {SPARK_STAGES.map((s) => (
            <li key={s.n} className="relative pl-16">
              <div className={`absolute left-0 top-1 h-12 w-12 rounded-full border-2 flex items-center justify-center font-display font-extrabold ${
                s.active
                  ? "border-brand-blue bg-brand-blue/20 text-brand-blue shadow-glow"
                  : "border-ink-700 bg-ink-900 text-silver-300"
              }`}>
                {String(s.n).padStart(2, "0")}
              </div>
              <div className="panel p-5">
                <div className="flex items-center gap-3">
                  <h3 className="display-md text-silver-50">{s.name}</h3>
                  {s.active ? <span className="chip">Live in MVP</span> : <span className="chip-silver">Roadmap</span>}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </Section>
  );
}
